import React, { Dispatch, FC } from 'react'
import './MinimumWageModal.scss'
import Modal from 'ps-components/Modal/Modal';
import ModalBody from 'ps-components/Modal/ModalBody/ModalBody';
import ModalFooter from 'ps-components/Modal/ModalFooter/ModalFooter';
import ModalHeader from 'ps-components/Modal/ModalHeader/ModalHeader';
import { deleteMinimumWage, formatDate, stateAbbrToName } from '../helpers';
import { useToast } from 'ps-shared-ui/v4/Toast';
import { MinimumWageReducerAction, MinimumWageStateI } from '../store';


interface DeleteWageConfirmationModalPropsI {
  state: MinimumWageStateI
  dispatch: Dispatch<MinimumWageReducerAction>
}

export const DeleteWageConfirmationModal: FC<DeleteWageConfirmationModalPropsI> = ({ state, dispatch }) => {
  const { selectedRow, modal, requestPending } = state
  if (!selectedRow) return null

  const toast = useToast()

  return (
    <div className='minimum-wage-modal'>
      <Modal onClose={() => dispatch({ type: 'SET_MODAL_CLOSED' })} show={modal.open && modal.name === 'DELETE_WAGE'}>
        <ModalHeader>
          <h3 className='minimum-wage-modal__title'>
            Are you sure you want to delete this record?
          </h3>
        </ModalHeader>
        <ModalBody>
          <div className='minimum-wage-modal__delete-body'>
            <div><strong>State:</strong> {stateAbbrToName(selectedRow.state)}</div>
            {selectedRow.city && <div><strong>City:</strong> {selectedRow.city}</div>}
            <div><strong>Minimum Wage:</strong> {selectedRow.minimum_wage}</div>
            <div><strong>Effective Date:</strong> {formatDate(selectedRow.effective_date)}</div>
          </div>
        </ModalBody>
        <ModalFooter
          cancelBtnClick={() => dispatch({ type: 'SET_MODAL_CLOSED' })}
          submitBtnClick={() => deleteMinimumWage(dispatch, selectedRow, toast)}
          submitBtnTxtName="Confirm"
          saveButtonDisabled={requestPending}
          hideCancelButton={requestPending}
        />
      </Modal>
    </div>
  )
}
